import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setBreedOverviewNavTabIdx } from 'dpl/actions/server';

import { NAVIGATION, NAV_SECTION_IDS } from '../utils/constants';
import BreedAtAGlanceSection from './BreedAtAGlanceSection';
import BreedOverviewSection from './BreedOverviewSection';
import BrowseAvailablePuppiesSection from './BrowseAvailablePuppiesSection';
import BreedAtAGlanceMobileSection from './BreedAtAGlanceMobileSection';
import AboutTheAuthorSection from './AboutTheAuthorSection';
import BreedHealthSectionContent from './BreedHealthSectionContent';
import BreedHistorySectionPhotos from './BreedHistorySectionPhotos';
import BreedScorecard from './BreedScorecard';
import FaqsSection from './FaqsSection';
import BreedRelatedLinks from './BreedRelatedLinks';
import RelatedBreedsList from './RelatedBreedsList';

export default function BreedOverviewLayout() {
  const { overviewPageData } = useSelector(({ server }) => server);
  const dispatch = useDispatch();

  useEffect(() => {
    function handleScroll() {
      const sections = document.querySelectorAll('[id$=Section]');
      const scrollYPosition = window.scrollY;

      sections.forEach(section => {
        const idx = Object.keys(NAVIGATION).findIndex(
          nav => nav === section.id
        );

        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (
          idx !== -1 &&
          // check that section is currently in view and accounts for 96px padding top
          scrollYPosition >= sectionTop - 96 &&
          scrollYPosition < sectionTop + sectionHeight
        ) {
          dispatch(setBreedOverviewNavTabIdx(idx));
        }
      });
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const breedOverviewSectionData = [
    {
      header: 'Appearance',
      subheader: overviewPageData.appearance.title,
      content: overviewPageData.appearance.long_description,
      id: NAV_SECTION_IDS.APPEARANCE
    },
    {
      header: 'Grooming',
      subheader: overviewPageData.grooming.title,
      content: overviewPageData.grooming.long_description,
      photo: overviewPageData.grooming_photo
    },
    {
      header: 'Breed temperament and characteristics',
      subheader: overviewPageData.temperment.title,
      content: overviewPageData.temperment.long_description,
      id: NAV_SECTION_IDS.TEMPERAMENT
    },
    {
      header: 'Exercise',
      subheader: overviewPageData.exercise.title,
      content: overviewPageData.exercise.long_description,
      photo: overviewPageData.exercise_photo
    },
    {
      header: 'Training',
      subheader: overviewPageData.training.title,
      content: overviewPageData.training.long_description
    },
    {
      header: 'Diet and nutrition',
      subheader: overviewPageData.diet.title,
      content: overviewPageData.diet.long_description,
      photo: overviewPageData.diet_photo
    },
    {
      header: 'Health issues',
      contentComponent: BreedHealthSectionContent,
      id: NAV_SECTION_IDS.HEALTH
    },
    {
      header: 'History',
      subheader: overviewPageData.history.title,
      content: overviewPageData.history.long_description,
      id: NAV_SECTION_IDS.HISTORY
    }
  ];

  return (
    <div className="BreedOverviewLayout">
      <BrowseAvailablePuppiesSection />
      <BreedAtAGlanceSection />
      <BreedAtAGlanceMobileSection />
      <BreedOverviewSection
        header="Why people love the breed"
        subheader={overviewPageData.why_people_love.title}
        content={overviewPageData.why_people_love.long_description}
      />
      {breedOverviewSectionData.map((section, index) => {
        return (
          <BreedOverviewSection
            key={index}
            header={section.header}
            subheader={section.subheader}
            content={section.content}
            ContentComponent={section.contentComponent}
            photo={section.photo}
            id={section.id}
          />
        );
      })}
      <BreedHistorySectionPhotos />
      <AboutTheAuthorSection vetReviewed={overviewPageData.vet_reviewed} />
      <BreedScorecard />
      <FaqsSection />
      <RelatedBreedsList />
      <BreedRelatedLinks />
    </div>
  );
}
